// Which photo address an avatar draws while a newer one loads (components/UserAvatar). Pure, so it is tested.

/**
 * Which address to draw now: the wanted one when it can show at once (already shown, nothing showing yet, or the
 * current one has no photo), otherwise the current one stays until the new photo has loaded (no blank frame).
 */
export function avatarToDraw(
  current: string | null,
  wanted: string | null,
  /** The browser can draw it at once (seen before) or it is known to have no photo. */
  settled: (src: string) => boolean,
  /** A photo is on screen for it now. */
  showing: (src: string) => boolean,
): string | null {
  if (current === wanted || wanted === null || current === null) return wanted;
  // Someone else's photo never stands in for this one: only a newer version of the same photo waits.
  if (photoPlace(current) !== photoPlace(wanted)) return wanted;
  return settled(wanted) || !showing(current) ? wanted : current;
}

/** The photo an address is of, whatever its version (`v=`) or size. */
export function photoPlace(src: string): string {
  return src.split('?')[0]!;
}
